import Gateway from 'features/gateway/domain/models/gateway';
import { SystemAlert } from 'features/systems/domain/models/system-alert';
import SystemDevice from 'features/systems/domain/models/system-device';
import { SystemStatus } from 'features/systems/domain/models/system-status';

export interface System {
  id?: string;
  type: SystemType;
  unitType?: SystemUnitType;
  name: string;
  hostName?: string;
  note?: string;
  macAddress?: string;
  ipAddress?: string;
  audioAvailable?: boolean;
  audioRecorderAvailable?: boolean;
  firmwareVersion?: string;
  lastCommunicationDate?: Date;
  status: SystemStatus;
  organisationUnitId?: string;
  gateway: Gateway;
  lastSystemEvent: SystemEvent | undefined;
  devices?: SystemDevice[];
  systemAlerts?: SystemAlert[];
  intercomFunctionalityAvailable: boolean;
  ioFunctionalityAvailable: boolean;
}

export interface SystemEvent {
  systemEventType: SystemEventType;
  systemEventStatus: SystemEventStatus;
  response: string;
  lastStatusChangeOn: Date;
}

export enum SystemEventType {
  Unknown = 'Unknown',
  ScanIS32Configuration = 'ScanIS32Configuration',
}

export enum SystemEventStatus {
  InProgress = 'InProgress',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
}

export enum SystemType {
  Unknown = '',
  IS32 = 'IS32',
  IPUnit = 'IPUnit',
  WanderingPreventionDeso = 'WanderingPreventionDeso',
  Domip = 'Domip',
}

export enum SystemUnitType {
  Unknown = 0,
  IPUnit = 1,
  IPUnitMolestResistant = 2,
}
